import { useEffect, useState } from 'react'

import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { api } from '@/shared/lib/api'

import { getConfig } from '../config'

export type ProgrammingKindCatalogEntry = {
  slug: string
  value: number
  name: string
}

/**
 * Catálogo de tipos de programação servido pela api.
 *
 * Existe para o rótulo do filtro não depender de deploy do front: tipo novo no
 * enum do Rails chega aqui com o nome já em pt-BR, e o participante vê o nome
 * em vez do enum cru — mesmo antes de o tipo ganhar ícone próprio em
 * `model/kind.ts`.
 *
 * Falha de rede não quebra a tela: sem catálogo o filtro cai na tradução local,
 * que cobre todos os tipos que o front já conhece. Por isso não há estado de
 * erro exposto — só a lista, vazia enquanto não carrega.
 */
export const useProgrammingKinds = (): ProgrammingKindCatalogEntry[] => {
  const { digitalProductId } = useDigitalProductContext()
  const [kinds, setKinds] = useState<ProgrammingKindCatalogEntry[]>([])

  useEffect(() => {
    if (!digitalProductId) return undefined

    let active = true
    const { apiBasePath } = getConfig({ digitalProductId })

    api
      .get(`${apiBasePath}/kinds`)
      .then(response => {
        if (!active) return
        setKinds(response.data?.records ?? [])
      })
      .catch(() => {
        // Silencioso de propósito — ver o comentário do hook.
        if (active) setKinds([])
      })

    return () => {
      active = false
    }
  }, [digitalProductId])

  return kinds
}
